module.exports = __webpack_public_path__ + "img/SES_69014320.384fcc8c.jpg";